import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { MockupSlot } from './MockupSlot';
import { OfferEndedButton } from './OfferEndedButton';
import { useOfferTimer } from '../../contexts/OfferTimerContext';
import { babyShowerCheckoutUrl } from '../../data/config';
import { bonusesTotal, bundleDiscountPercent, bundleReferenceValue, formatArs, pricing, pricingFlags } from '../../data/babyShowerPricing';
import { offerExtraBonuses, offerIncludedItems, offerMockupImage } from '../../data/babyShowerOffer';
const offerCopy = {
  eyebrow: 'Baby Shower Dulce Recuerdo',
  title: '¡Tené resuelta la diversión de tu Baby Shower y lucite organizando!',
  subtitle: 'Ya preparamos los juegos para vos: llevate 30 imprimibles y recibí 50 dinámicas de regalo para que tus amigas y tu familia se diviertan y vos también disfrutes.',
  packSummary: '30 juegos imprimibles + 4 bonos incluidos',
  priceLead: 'Precio final del pack',
  priceNote: 'Pago único · Acceso digital',
  bonusLine: '¡Y te llevás los 4 bonos sin pagar extra!',
  cta: 'Quiero mi kit completo →'
};
const ctaClass = 'flex w-full items-center justify-center rounded-full bg-gradient-to-r from-[#E74D7A] to-[#EC6A92] px-6 py-4 text-center font-display text-[17px] font-extrabold uppercase leading-snug tracking-tight text-white shadow-[0_14px_30px_-12px_rgba(231,77,122,0.65)] transition-transform duration-150 ease-out hover:scale-[1.01] hover:from-[#DE3F6E] hover:to-[#E74D7A] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E74D7A] focus-visible:ring-offset-2 active:scale-[0.98] sm:py-5 sm:text-xl';
export function PricingOffer() {
  const {
    expired
  } = useOfferTimer();
  const items = [...offerIncludedItems, ...offerExtraBonuses.map(b => ({
    label: b.label,
    isBonus: true
  }))];
  return <section id="ajanlat" aria-labelledby="offer-title" className="scroll-mt-16 bg-[#FBF6EE] py-11 md:py-16" data-id="element-285" data-mp="3czw7re7hq2m">
      <div className="mx-auto max-w-xl px-5" data-id="element-286" data-mp="3vhlmfvvtjtwo">
        <header className="text-center" data-id="element-287" data-mp="3viwqlwt6f3ob">
          <p className="inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-288" data-mp="6f4fdzbg7u90">
            {offerCopy.eyebrow}
          </p>
          <h2 id="offer-title" className="mx-auto mt-4 max-w-[24ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2rem]" data-id="element-289" data-mp="gbh4ejw1tjxf">
            {offerCopy.title}
          </h2>
          <p className="mx-auto mt-3 max-w-md text-[16px] leading-relaxed text-body" data-id="element-290" data-mp="u46uazep78zt">{offerCopy.subtitle}</p>
        </header>

        <div className="mt-7 rounded-[2rem] border border-[#EFE4D6] bg-white p-3 shadow-[0_24px_50px_-30px_rgba(139,107,85,0.55)] sm:p-4" data-id="element-291" data-mp="z39xeeb4b555">
          <MockupSlot src={offerMockupImage} alt="Pack completo Baby Shower Dulce Recuerdo" slot="offer-mockup" label="Pack completo: 30 juegos imprimibles + bono de 50 dinámicas" tone="pink" data-id="element-292" data-mp="141uz6i60pwvp" />

          <div className="px-2 pb-3 pt-5 sm:px-4 sm:pb-4" data-id="element-293" data-mp="35u9fxdwtsvaj">
            <p className="mb-4 text-center font-display text-[17px] font-extrabold leading-snug text-[#4A3A35] sm:text-[18px]" data-id="element-294" data-mp="1mz4w9eii8ng0">
              {offerCopy.packSummary}
            </p>
            <ul className="space-y-2.5" data-id="element-295" data-mp="1e6bdv87rh7xx">
              {items.map(item => <li key={item.label} className="flex items-start gap-3 text-[15px] leading-snug text-[#4A3A35] sm:text-[16px]" data-id="element-296" data-mp="1e4gtpw4bdjuw">
                  <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${item.isBonus ? 'bg-[#DDF2F1] text-[#15ADA8]' : 'bg-[#FDE3EC] text-[#E74D7A]'}`} aria-hidden="true" data-id="element-297" data-mp="25xh9bbcjehgv">
                    {item.isBonus ? <GiftIcon className="h-3 w-3" strokeWidth={2.5} data-id="element-298" data-mp="1ww9n3rnap735" /> : <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-299" data-mp="1wyvu9q69xkku" />}
                  </span>
                  <span data-id="element-300" data-mp="1s02e1pzlrfgz">
                    {item.isBonus && !expired && <span className="mr-1.5 inline-block rounded-full bg-[#C4E8E6] px-2 py-0.5 align-[1px] text-[11px] font-extrabold uppercase tracking-[0.06em] text-[#0E7C78]" data-id="element-301" data-mp="lixez4ki62b6">
                        Hoy gratis
                      </span>}
                    {item.label}
                  </span>
                </li>)}
            </ul>

            {expired ? <div className="mt-5 border-t border-dashed border-[#EADFCF] pt-5 text-center" data-id="element-302" data-mp="298216kfsraej">
                <p className="font-display text-[1.5rem] font-extrabold leading-tight text-[#4A3A35] sm:text-[1.75rem]" data-id="element-303" data-mp="1vcpxhnjny9lh">Esta oferta finalizó</p>
                <p className="mx-auto mt-2 max-w-sm text-[15px] leading-relaxed text-body" data-id="element-304" data-mp="2o38777ew797v">
                  El precio promocional ya no está disponible.
                </p>
                <div className="mt-5" data-id="element-305" data-mp="2e5ahsglar6do">
                  <OfferEndedButton data-id="element-306" data-mp="2e4903t9rzlmz" />
                </div>
              </div> : <>
            <p className="mt-4 rounded-xl bg-[#DDF2F1] px-3 py-2 text-center text-[15px] font-bold text-[#0E7C78]" data-id="element-307" data-mp="2j3lv51asvz0n">
              {offerCopy.bonusLine}
            </p>

            <div className="mt-5 border-t border-dashed border-[#EADFCF] pt-5 text-center" data-id="element-308" data-mp="17p8ae5bcfzou">
              {pricingFlags.showBundleReferenceValue && <div className="mx-auto max-w-sm rounded-2xl bg-[#FAF0E7] px-4 py-3 text-[14px] text-body" style={{
                paddingTop: "0px"
              }} data-id="element-309" data-mp="104xos4a358gh">
                  
                  
                  <div className="mt-2 flex items-center justify-between gap-3 border-t border-[#EADFCF] pt-2 font-bold text-[#4A3A35]" data-id="element-310" data-mp="195cc196m0xmm">
                    <span data-id="element-311" data-mp="1457tzeq1zuua">Valor total</span>
                    <span className="flex items-center gap-2" data-id="element-312" data-mp="gh85ymk4mije">
                      <s className="decoration-[#E74D7A] decoration-2" data-id="element-313" data-mp="gfdib0hh0cbm">{formatArs(bundleReferenceValue)}</s>
                      {pricingFlags.showDiscountBadge && <span className="rounded-full bg-[#15ADA8] px-2 py-0.5 text-[11px] font-extrabold uppercase tracking-[0.04em] text-white" data-id="element-314" data-mp="q7syptd4csue">
                          {bundleDiscountPercent}% off
                        </span>}
                    </span>
                  </div>
                </div>}
              <p className="mt-3 text-[15px] font-semibold text-body" data-id="element-315" data-mp="3oybaexrljltd">{offerCopy.priceLead}</p>
              <p className="mt-1 font-display text-[3rem] font-extrabold leading-none tracking-[-0.03em] text-[#4A3A35] sm:text-[3.5rem]" data-id="element-316" data-mp="1sv6lppvvfjn1">
                {formatArs(pricing.offerPrice)} <span className="text-[1.25rem] tracking-normal" data-id="element-317" data-mp="22k7y7637jiw9">ARS</span>
              </p>
              <p className="mt-2.5 text-[14px] font-medium text-body" data-id="element-318" data-mp="22mkhpnom61bf">{offerCopy.priceNote}</p>

            </div>

            <div className="mt-5" data-id="element-319" data-mp="19vsl4p3mzank">
              {babyShowerCheckoutUrl ? <a href={babyShowerCheckoutUrl} data-checkout="ready" className={ctaClass} data-id="element-320" data-mp="19xdfadm1grkw">
                  {offerCopy.cta}
                </a> : <button type="button" data-checkout="pending" className={ctaClass} data-id="element-321" data-mp="1jtqchlgslnke">
                  {offerCopy.cta}
                </button>}
            </div>
            </>}
          </div>
        </div>
      </div>
    </section>;
}